import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { pointsEndpointIds } from 'root/src/shared/points/points.constants';
export const sendDropLaunchDateChangedEmailEndpoint = {
    [pointsEndpointIds.SEND_DROP_LAUNCH_DATE_CHANGED_EMAIL]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string' },
            },
            required: ['dropId'],
            additionalProperties: false,
        },
    },
};
